import {
  Award,
  Briefcase,
  Clock,
  GraduationCap,
  Heart,
  Shield,
  TrendingUp,
  Users,
  MapPin,
  Phone,
  MoveRight
} from "lucide-react";

import { images } from "../../assets/assets";
import Navbar from "../../Components/Navbar";
import { Link } from "react-router-dom";
import Footer from "../../Components/Footer";
import { getImageUrl } from "../../utils/getImageUrl";
import { useState, useEffect } from "react";
import { getAllJobsOpenings } from "../../api";

const Career = () => {

  const [jobOpenings, setJobOpenings] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)


  useEffect(() => {
    const fetchJobOpenings = async () => {
      try {
        setLoading(true)
        setError(null)
        const data = await getAllJobsOpenings()
        setJobOpenings(data?.data || [])
      } catch (err) {
        console.error("Failed to fetch job openings:", err)
        setError("Failed to load job openings. Please try again later.")
        setJobOpenings([])
      } finally {
        setLoading(false)
      }
    }

    fetchJobOpenings()
  }, [])

  const benefits = [
    {
      icon: (
        <Heart
          className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 transition-colors duration-500 group-hover:text-red-500"
          color="currentColor"
        />
      ),
      title: "Healthcare Benefits",
      desc: "Comprehensive health insurance for you and your family",
    },
    {
      icon: (
        <GraduationCap
          className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 transition-colors duration-500 group-hover:text-blue-500"
          color="currentColor"
        />
      ),
      title: "Continuous Learning",
      desc: "CME programs, workshops, and sponsored training opportunities",
    },
    {
      icon: (
        <TrendingUp
          className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 transition-colors duration-500 group-hover:text-yellow-500"
          color="currentColor"
        />
      ),
      title: "Career Growth",
      desc: "Clear career progression paths and promotion opportunities",
    },
    {
      icon: (
        <Shield
          className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 transition-colors duration-500 group-hover:text-green-500"
          color="currentColor"
        />
      ),
      title: "Job Security",
      desc: "Stable employment with a reputed healthcare institution",
    },
    {
      icon: (
        <Award
          className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 transition-colors duration-500 group-hover:text-purple-500"
          color="currentColor"
        />
      ),
      title: "Recognition",
      desc: "Performance-based incentives and awards",
    },
    {
      icon: (
        <Clock
          className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 transition-colors duration-500 group-hover:text-orange-500"
          color="currentColor"
        />
      ),
      title: "Work-Life Balance",
      desc: "Flexible schedules and adequate leave policies",
    },
  ];

  // const jobOpenings = [
  //   {
  //     Img: images.CareerOpeningOne,
  //     title: "Senior Medical Officer",
  //     category: "Medicine",
  //     location: "Dev Rishi Hospital",
  //     type: "Full Time",
  //     experience: "5+ years",
  //     description: "We are looking for an experienced Medical Officer to join our Medicine Department. The ideal candidate will have strong clinical skills and a passion for patient care.",
  //     features: [
  //       "MBBS with MD in Medicine",
  //       "Valid medical license",
  //       "5+ years of clinical experience",
  //       "Excellent diagnostic and treatment skills",
  //       "Strong communication abilities",
  //     ],
  //     responsibilities: [
  //       "Diagnose and treat patients with various medical conditions",
  //       "Conduct ward rounds and outpatient consultations",
  //       "Supervise junior doctors and medical students",
  //       "Maintain accurate medical records",
  //       "Participate in emergency duty roster",
  //     ],
  //   },
  //   {
  //     Img: images.CareerOpeningTwo,
  //     jobTitle: "Staff Nurse",
  //     category: "ICU",
  //     location: "Dev Rishi Hospital",
  //     type: "Full Time",
  //     experience: "2-3 years",
  //     desc: "Seeking a dedicated and compassionate Staff Nurse to join our Intensive Care Unit at Dev Rishi Hospital. The ideal candidate should be capable of handling critical patients and working efficiently in high-pressure situations.",
  //     features: [
  //       "B.Sc. Nursing or GNM",
  //       "Registered Nurse license",
  //       "2-3 years ICU experience preferred",
  //       "BLS and ACLS certification",
  //       "Excellent patient care skills",
  //     ],
  //     responsibilities: [
  //       "Provide direct patient care in ICU setting",
  //       "Monitor vital signs and patient conditions",
  //       "Administer medications and treatments",
  //       "Maintain patient records and documentation",
  //       "Collaborate with medical team",
  //     ],
  //   },
  // ];

  return (
    <div className="font-lato">
      <Navbar />

      {/* Hero Banner */}
      <div
        className="py-6 sm:py-8 md:py-4 flex flex-col sm:flex-row gap-4 items-center justify-center w-full bg-center bg-cover relative px-4"
        style={{
          backgroundImage: `linear-gradient(#00000099, #00000099), url(${images.CareerBanner})`,
        }}
      >
        <div className="flex flex-col sm:flex-row justify-center sm:justify-start gap-2 sm:gap-4 items-center max-w-[1100px]">
          <img
            src={images.Logo}
            alt="logo"
            className="w-[50px] h-[50px] sm:w-[80px] sm:h-[80px] md:w-[95px] md:h-[95px] flex-shrink-0 hover:scale-105 transition-transform duration-300"
          />
          <div className="max-w-[700px] text-white">
            <p className="font-bold text-[16px] sm:text-[20px] md:text-[24px] text-center sm:text-left">
              Join Our Team
            </p>
            <p className="font-openSans text-[12px] sm:text-[14px] md:text-[16px] leading-[1.2] text-center sm:text-left">
              Join our team at Dev Rishi Hospital and build a rewarding career
              in a dynamic healthcare environment. We offer opportunities to
              grow, learn, and make a meaningful impact on patients' lives. Our
              workplace encourages collaboration, innovation, and continuous
              professional development.
            </p>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <section className="px-4 pt-6 sm:pt-8 md:pt-10 pb-2 sm:pb-4">
        <h1 className="text-[24px] sm:text-[28px] md:text-[34px] font-semibold leading-[1.2] text-center">
          Why Choose Dev Rishi Hospital?
        </h1>
        <p className="max-w-[830px] mx-auto text-[14px] sm:text-[16px] md:text-[18px] leading-[1.5] text-center text-black mt-2 sm:mt-3">
          Join a team of dedicated healthcare professionals committed to
          excellence at Dev Rishi Hospital. We foster a supportive and
          collaborative environment where your skills and contributions are
          valued. Our focus on continuous learning and innovation helps you grow
          both professionally and personally.
        </p>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 max-w-[860px] mx-auto my-4 sm:my-6 md:my-8">
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="border border-[#B9B9B9] p-5 sm:p-6 rounded-[20px] text-center group
                hover:border-transparent hover:shadow-[0px_10px_35px_0px_#CECDDA66]
                hover:-translate-y-2 hover:bg-[#F8FAFF]
                active:scale-[0.97] active:shadow-inner active:translate-y-0
                transition-all duration-300 cursor-pointer"
            >
              <div
                className="bg-[#F1F1F1] p-3 md:p-4 rounded-full inline-flex items-center justify-center
                group-hover:bg-white group-hover:shadow-md transition-all duration-300"
              >
                {benefit.icon}
              </div>
              <p className="font-semibold text-[15px] sm:text-[17px] md:text-[19px] my-3">
                {benefit.title}
              </p>
              <p className="max-w-[200px] mx-auto text-[#545454] text-[12px] sm:text-[13px] md:text-[14px] leading-[1.5]">
                {benefit.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us - Section 2 (Culture) */}
      <section className="px-4 py-0 sm:py-4">
        <h1 className="text-[24px] sm:text-[28px] md:text-[34px] font-semibold leading-[1.2] text-center">
          Why Choose Dev Rishi Hospital?
        </h1>
        <p className="max-w-[830px] mx-auto text-[14px] sm:text-[16px] md:text-[18px] leading-[1.5] text-center text-black mt-2 sm:mt-3">
          Join a team of dedicated healthcare professionals committed to
          excellence at Dev Rishi Hospital. We foster a supportive and
          collaborative environment where your skills and contributions are
          valued. Our focus on continuous learning and innovation helps you grow
          both professionally and personally.
        </p>

        {/* Culture Grid */}
        <div className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-[1fr_320px] lg:grid-cols-[1fr_350px] place-items-center gap-6 sm:gap-8 my-4 sm:my-6 md:my-8">
          <div className="space-y-2">
            <div className="flex gap-2 p-4 hover:bg-[#F5F9FF] hover:shadow-sm rounded-[16px] transition-all duration-300 group">
              <Users
                color="#1975FF"
                className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 flex-shrink-0"
              />
              <div>
                <p className="font-semibold text-[17px] sm:text-[19px] md:text-[21px] leading-[1.2] group-hover:text-[#1975FF] transition-all duration-300">
                  Collaborative Environment
                </p>
                <p className="text-[13px] sm:text-[14px] md:text-[15px] text-black leading-[1.2] mt-1">
                  Work alongside skilled professionals in a team-oriented
                  setting
                </p>
              </div>
            </div>
            <div className="flex gap-2 p-4 hover:bg-[#F5F9FF] hover:shadow-sm rounded-[16px] transition-all duration-300 group">
              <GraduationCap
                color="#1975FF"
                className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 flex-shrink-0"
              />
              <div>
                <p className="font-semibold text-[17px] sm:text-[19px] md:text-[21px] leading-[1.2] group-hover:text-[#1975FF] transition-all duration-300">
                  Professional Development
                </p>
                <p className=" text-[13px] sm:text-[14px] md:text-[15px] text-black leading-[1.2] mt-1">
                  Access to training programs and continuous medical education
                </p>
              </div>
            </div>
            <div className="flex gap-2 p-4 hover:bg-[#F5F9FF] hover:shadow-sm rounded-[16px] transition-all duration-300 group">
              <Users color="#1975FF" className="w-7 h-7" />
              <div>
                <p className="font-semibold text-[17px] sm:text-[19px] md:text-[21px] leading-[1.2] group-hover:text-[#1975FF] transition-all duration-300">
                  Patient-Centered Care
                </p>
                <p className="text-[13px] sm:text-[14px] md:text-[15px]  text-black leading-[1.2] mt-1">
                  Focus on compassionate, quality care for every patient
                </p>
              </div>
            </div>
          </div>
          <img
            src={images.CareerPageDoctorImage}
            alt="doctor"
            className="w-full max-w-[320px] sm:max-w-[350px] h-[260px] sm:h-[300px] md:h-[320px] rounded-[30px] object-cover object-center
              hover:shadow-[0px_15px_40px_0px_#1975FF33] hover:-translate-y-1
              active:scale-[0.98] transition-all duration-500"
            loading="lazy"
          />
        </div>
      </section>

      {/* Current Openings */}
      <section className="px-2 pb-6 flex flex-col justify-center items-center">
        <h1 className="text-[24px] sm:text-[28px] md:text-[34px] font-semibold leading-[1.2] text-center mt-4">
          Current Openings
        </h1>
        <p className="max-w-[830px] mx-auto text-[14px] sm:text-[16px] md:text-[18px] leading-[1.2] text-center text-black mt-2 mb-2">
          Explore opportunities to join our growing team
        </p>

      {/* <Link to="/contact" className="border mt-3.5  rounded-[8px] sm:rounded-[10px] py-2 sm:py-1 px-3 sm:px-3 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white bg-[#1975FF] hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"> 
                   <span>Apply Now</span>
                     <MoveRight
                        color="#000"
                        className="rotate-[-38deg] md:w-7 w-3.5 bg-white p-2 rounded-full md:h-7 h-3.5 sm:w-4 sm:h-4"
                      />
                      
      </Link> */}
      </section>
  
       <div className="space-y-5 max-w-[1050px] mx-auto mt-5">
          
          {error && (
            <div className="p-4 sm:p-5 bg-red-50 border border-red-200 rounded-[16px] text-center">
              <p className="text-red-600 font-semibold text-[14px] sm:text-[15px]">
                {error}
              </p>
            </div>
          )}

         
          {loading ? (
            Array.from({ length: 2 }).map((_, idx) => (
              <div
                key={idx}
                className="p-4 sm:p-5 sm:pr-16 bg-white border border-[#B9B9B9] rounded-[24px] sm:rounded-[30px]
                  shadow-[0px_0px_25px_0px_#CECDDA33] animate-pulse"
              >
                <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
                  <div className="w-full sm:w-[280px] md:w-[320px] lg:w-[340px] h-[180px] sm:h-[160px] md:h-[175px] bg-gray-300 rounded-[16px] sm:rounded-[20px] flex-shrink-0" />
                  <div className="flex-1 min-w-0 w-full space-y-3">
                    <div className="h-5 bg-gray-300 rounded w-3/4" />
                    <div className="flex flex-wrap gap-2 sm:gap-3">
                      <div className="h-4 bg-gray-300 rounded w-24" />
                      <div className="h-4 bg-gray-300 rounded w-32" />
                    </div>
                    <div className="space-y-2">
                      <div className="h-4 bg-gray-300 rounded w-full" />
                      <div className="h-4 bg-gray-300 rounded w-5/6" />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 pt-4 mt-4">
                  <div className="space-y-2">
                    <div className="h-4 bg-gray-300 rounded w-40" />
                    <div className="space-y-1.5">
                      {Array.from({ length: 3 }).map((_, i) => (
                        <div key={i} className="h-3 bg-gray-300 rounded w-full" />
                      ))}
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div className="h-4 bg-gray-300 rounded w-40" />
                    <div className="space-y-1.5">
                      {Array.from({ length: 3 }).map((_, i) => (
                        <div key={i} className="h-3 bg-gray-300 rounded w-full" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : jobOpenings && jobOpenings.length > 0 ? (
            jobOpenings.map((opening, idx) => (
              <div
                key={idx}
                className="p-4 sm:p-5 sm:pr-16 bg-white border border-[#B9B9B9] rounded-[24px] sm:rounded-[30px]
                  shadow-[0px_0px_25px_0px_#CECDDA33]
                  hover:shadow-[0px_8px_40px_0px_#1975FF18] hover:border-[#C5D9FF]
                  active:shadow-inner active:scale-[0.995]
                  transition-all duration-300 font-poppins"
              >
         
                <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
                  <img
                    src={getImageUrl(opening?.imagePath)}
                    alt={`opening-image-${idx}`}
                    className="w-full sm:w-[280px] md:w-[320px] lg:w-[340px] h-[180px] sm:h-[160px] md:h-[175px] object-cover rounded-[16px] sm:rounded-[20px] flex-shrink-0
                      hover:scale-[1.02] hover:shadow-md transition-all duration-300"
                  />
                  <div className="flex-1 min-w-0">
                    <h3 className="font-poppins font-semibold text-[15px] sm:text-[16px] md:text-[17px] text-black mb-1 sm:mb-2">
                      {opening.title}
                    </h3>
                    <div className="flex flex-wrap gap-2 sm:gap-3 items-center mb-2 sm:mb-3">
                      <div
                        className="flex gap-1.5 items-center text-[#515151]
                        hover:text-[#1975FF] transition-colors duration-200"
                      >
                        <Briefcase className="w-4 h-4" />
                        <p className="text-[12px] sm:text-[13px]">
                          {opening.category}
                        </p>
                      </div>
                      <div
                        className="flex gap-1.5 items-center text-[#515151]
                        hover:text-[#1975FF] transition-colors duration-200"
                      >
                        <MapPin className="w-4 h-4" />
                        <p className="text-[12px] sm:text-[13px]">
                          {opening.location}
                        </p>
                      </div>
                      <div
                        className="flex gap-1.5 items-center text-[#515151]
                        hover:text-[#1975FF] transition-colors duration-200"
                      >
                        <Clock className="w-4 h-4" />
                        <p className="text-[12px] sm:text-[13px]">
                          {opening.type}
                        </p>
                      </div>
                      <span className="py-0.5 px-3 rounded-[14px] bg-[#C1E2FF] text-[12px] sm:text-[13px] text-[#0088FF] font-medium">
                        {opening.experience}
                      </span>
                    </div>
                    <p className="text-[13px] sm:text-[14px] text-[#444] leading-[1.5]">
                      {opening.description}
                    </p>
                  </div>
                </div>

               
                <div className=" sm:pl-8">
                  
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 pt-1 sm:pt-4 mt-2 ">
                  <div>
                    <p className="text-[13px] sm:text-[14px] font-semibold text-black mb-2">
                      Key Requirements:
                    </p>
                    <ul className="space-y-1.5">
                      {opening.features && opening.features.map((feature, i) => (
                        <li key={i} className="flex gap-2 items-start group/item">
                          <img
                            src={images.JobOpeningCheckIcon}
                            alt="check"
                            className="h-[14px] sm:h-[15px] mt-[3px] flex-shrink-0 group-hover/item:scale-110 transition-transform duration-200"
                          />
                          <p className="text-[12px] sm:text-[13px] md:text-[14px] text-[#333] leading-[1.4]">
                            {feature}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <p className="text-[13px] sm:text-[14px] font-semibold text-black mb-2">
                      Responsibilities:
                    </p>
                    <ul className="space-y-1.5">
                      {opening.responsibilities && opening.responsibilities.map((resp, i) => (
                        <li key={i} className="flex gap-2 items-start group/item">
                          <img
                            src={images.JobOpeningCheckIcon}
                            alt="check"
                            className="h-[14px] sm:h-[15px] mt-[3px] flex-shrink-0 group-hover/item:scale-110 transition-transform duration-200"
                          />
                          <p className="text-[12px] sm:text-[13px] md:text-[14px] text-[#333] leading-[1.4]">
                            {resp}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

             
                <Link
                  to={`/apply/${opening?._id || opening?.id}`}
                  className="mt-4 block bg-[#1975FF] rounded-[10px] py-2.5 px-4 font-semibold text-[13px] sm:text-[14px]
                    text-white text-center
                    hover:bg-[#155FD4] hover:shadow-[0px_6px_20px_0px_#1975FF55] hover:-translate-y-0.5
                    active:scale-[0.98] active:bg-[#1155BB] active:translate-y-0 active:shadow-none
                    transition-all duration-200"
                >
                  Apply Now
                </Link>
                
                </div>
              </div>
            ))
          ) : (
            <div className="p-6 sm:p-8 bg-[#F7F7F7] border border-[#B9B9B9] rounded-[16px] text-center">
              <p className="text-[#666] font-semibold text-[14px] sm:text-[15px]">
                No job openings available at the moment. Please check back later.
              </p>
            </div>
          )}
        </div>
       

      {/* Ayushman Bharat CTA */}
      <div className="py-8 sm:py-10 md:py-12 bg-[#F7F7F7B2] px-4 mt-3 sm:mt-4 md:mt-5 mb-8 sm:mb-10 md:mb-14">
        <h1 className="max-w-[550px] text-center text-[20px] sm:text-[26px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
          Need Help with Ayushman Bharat?
        </h1>
        <p className="max-w-[600px] font-openSans text-[13px] sm:text-[16px] md:text-[18px] mx-auto text-center mt-3 px-2">
          Visit our Ayushman Bharat helpdesk or contact us for assistance
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8">
          <a
            href="tel:+917300906444"
            className="border  rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-1 px-3 sm:px-3 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white bg-[#1975FF] hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
          >
            <span className="p-2 bg-white rounded-full transition-all duration-300 group-hover:bg-white">
              <Phone color="#000" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            </span>
            Call Helpdesk
          </a>
          <a
            href="#"
            className="border border-black rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-0.5 px-3 sm:px-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-black hover:bg-black hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
          >
            Visit Hospital
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Career;
